import {message, Button, Col, Layout, Row} from 'antd';
import { RouteComponentProps } from 'react-router';
import { Content } from 'antd/lib/layout/layout';
import OAMSider from "../oam-sider";
import Cookies from 'js-cookie';
import { sendHttpPostRequest } from '../../../api/http-request';

import MenuEdit from './menu-edit';

import React, { useState, useEffect} from "react";

// 通过路由组件额外添加参数信息到表中
interface Props {

}

export const OAMMenuCreate: React.FC<Props> = (props: Props) => {
    const [menuId, setMenuId] =  useState(null as any);
   
    //点击了查看按钮
    const onLookOverBtnClick = (event:any) => {
        //message.success('查看数据' + event.currentTarget.value)
        event.preventDefault()
        window.open('/oam_menu_detail?menu_id=' + menuId)
    }

    useEffect(() => {
        createMenu();
    }, [])

    /**
     * 创建大纲
     */
     const createMenu = () => {
        sendHttpPostRequest(
            'course/api/oam_create_menu',
            {
                sessionid: Cookies.get("sessionid"),
            },
            createMenuCallback
        )
    }
  
    /**
     * 创建大纲回调
     * @param response
     */
    const createMenuCallback = (response: any) => {
        // console.log(response)
        message.destroy();
        if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_menu';
        } else if (response.is_ok == true) {
            // 成功
            setMenuId(response.menu_id);
            message.success(response.menu_id);
           
        } /*else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=oam_menu';
        } */else {
            message.error(response.message);
        }
    }



    return (
        <Layout style={{ minHeight: '100vh' }}>
        <OAMSider keys={"3"} openKeys={["sub-project"]}></OAMSider>
        <div style={{marginLeft:"auto",marginRight:'auto',marginTop:30 }}>
            <Content style={{ backgroundColor:'#fff',minHeight: '90vh',borderRadius:5,minWidth:800,padding:20}}>

                <div style={{paddingLeft:30,paddingRight:30}}>
                    { menuId && 
                    <MenuEdit menu_id={menuId} />    }
                </div>
            </Content>
        </div>
    </Layout>
    )
}

export default OAMMenuCreate

